import * as congNoConstant from './constants'

export const congNoListRequest = (formData) => {
  return {
    type: congNoConstant.CONGNO_NV_LIST_REQUESTING,
    formData
  }
}

export const congNoListSuccess = (data) => {
  return {
    type: congNoConstant.CONGNO_NV_LIST_SUCCESS,
    data
  }
}

export const congNoListError = (error) => {
  return {
    type: congNoConstant.CONGNO_NV_LIST_ERROR,
    error
  }
}

export const reportExportXlsRequest = (formData, callback) => {
  return {
    type: congNoConstant.CONGNO_NV_EXPORT_XLS_REQUESTING,
    formData,
    callback
  }
}

export const reportExportXlsSuccess = (data) => {
  return {
    type: congNoConstant.CONGNO_NV_EXPORT_XLS_SUCCESS,
    data
  }
}

export const reportExportXlsError = (error) => {
  return {
    type: congNoConstant.CONGNO_NV_EXPORT_XLS_ERROR,
    error
  }
}

export const congNoDvhcListRequest = (formData) => {
  return {
    type: congNoConstant.CONGNO_NV_DVHC_LIST_REQUESTING,
    payload: formData
  }
}

export const congNoDvhcListSuccess = (data) => {
  return {
    type: congNoConstant.CONGNO_NV_DVHC_LIST_SUCCESS,
    data
  }
}

export const congNoDvhcListError = (error) => {
  return {
    type: congNoConstant.CONGNO_NV_DVHC_LIST_ERROR,
    error
  }
}

export const congNoNvkdListRequest = (formData) => {
  return {
    type: congNoConstant.CONGNO_NV_NVKD_LIST_REQUESTING,
    payload: formData
  }
}

export const congNoNvkdListSuccess = (data) => {
  return {
    type: congNoConstant.CONGNO_NV_NVKD_LIST_SUCCESS,
    data
  }
}

export const congNoNvkdListError = (error) => {
  return {
    type: congNoConstant.CONGNO_NV_NVKD_LIST_ERROR,
    error
  }
}


export const congNoNvUpdateRequest = (formData, callback) => {
  return {
    type: congNoConstant.CONGNO_NV_UPDATE_REQUESTING,
    payload: formData,
    callback
  }
}

export const congNoNvUpdateSuccess = (response) => {
  return {
    type: congNoConstant.CONGNO_NV_UPDATE_SUCCESS,
    payload: response
  }
}

export const congNoNvUpdateError = (error) => {
  return {
    type: congNoConstant.CONGNO_NV_UPDATE_ERROR,
    error
  }
}


// WEBPACK FOOTER //
// ./src/views/CongNoNhanVien/actions.js